export default "__VITE_ASSET__BGlLc5Lg__"